import React, { ImgHTMLAttributes } from "react";
import square_skeleton_loader from "../../assets/svg/square-skeleton-loader.svg";

interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  className?: string;
  src: string;
  alt: string;
  width?: string;
  height?: string;
  onClick?: (e: React.MouseEvent<HTMLImageElement>) => void;
}

const Img = ({ alt, src, className, width, height, onClick }: ImageProps) => {
  return (
    <img
      src={src}
      onClick={onClick}
      className={className}
      width={width || 200}
      height={height || 100}
      loading="lazy"
      decoding="async"
      alt={alt}
      srcSet={src || square_skeleton_loader}
    />
  );
};

export default Img;
